import { RevealGobanElement } from './element.js';

export const REVEAL_GOBAN_TAG_NAME = 'reveal-goban';

/**
 * Registers `<reveal-goban>` as a custom element. Safe to call more than
 * once (e.g. from both the main entry point and the Reveal plugin) —
 * subsequent calls are no-ops.
 */
export function defineRevealGoban(): void {
  if (typeof customElements === 'undefined') return;
  if (customElements.get(REVEAL_GOBAN_TAG_NAME)) return;
  customElements.define(REVEAL_GOBAN_TAG_NAME, RevealGobanElement);
}
